import React, { createContext, useState, useMemo, useCallback } from 'react'
import CamVUService from '../../services/CamVU/CamVU.service'
import PropTypes from 'prop-types'
import { trackEvent } from '../../utils/functions'

export const CamVUContext = createContext()

export const CamVUContextProvider = (props) => {
  const [allScreens, setAllScreens] = useState([])

  const fetchScreens = useCallback(async (portalName) => {
    try {
      const res = await CamVUService.fetchScreens(portalName)
      setAllScreens(res.data)
    } catch (err) {
      // Error fetching screens
    }
  }, [])

  const addScreen = useCallback(async (screenName, screenURL, portalName) => {
    trackEvent('ScreenVU Added')
    return await CamVUService.addScreen(screenName, screenURL, portalName)
  }, [])

  const removeScreen = useCallback(async (screenName, portalName) => {
    trackEvent('ScreenVU Removed')
    return await CamVUService.removeScreen(screenName, portalName)
  }, [])

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({ fetchScreens, addScreen, removeScreen, allScreens }),
    [fetchScreens, addScreen, removeScreen, allScreens]
  )

  return (
    <CamVUContext.Provider value={contextValue}>
      {props.children}
    </CamVUContext.Provider>
  )
}

CamVUContextProvider.propTypes = {
  children: PropTypes.object
}
